import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: {},
};

export default function promotorsSetCurrentReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.SET_CURRENT_PROMOTOR_INIT:
      return { ...state, error: null, isLoading: true };

    case types.SET_CURRENT_PROMOTOR_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.SET_CURRENT_PROMOTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
